import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { apiStates, useApi } from "./hooks/useApi";
import { StateProvider } from "./State";
import SearchOfficeView from "./SearchOfficeView";

function SearchOfficeEntry({ apiSettings }) {
  const api = useApi(apiSettings.offices);
  switch (api.state) {
    case apiStates.ERROR:
      return <p>{api.error || "Something wrong with api"}</p>;
    case apiStates.SUCCESS:
      return (
        <StateProvider initialState={api}>
          <SearchOfficeView
            hideshowmypositionlink={JSON.parse(apiSettings.hideshowmypositionlink)}
            mapid={apiSettings.mapid}
            nonce={apiSettings.nonce}
          />
        </StateProvider>
      );
    default:
      return <p>laddar...</p>;
  }
}

SearchOfficeEntry.propTypes = {
  apiSettings: PropTypes.shape({
    offices: PropTypes.string,
    query: PropTypes.string,
    hideshowmypositionlink : PropTypes.string,
    mapid: PropTypes.string
  }),
};

const appContainer = document.querySelector("#search-office-app");

if (appContainer) {
  const { headers, ...apiSettings } = appContainer.dataset;
  ReactDOM.render(
    <SearchOfficeEntry apiSettings={apiSettings} />,
    appContainer
  );
}

export default SearchOfficeEntry;
